export const googleReviewCount = 323858
export const appleReviewCount = 549195
export const reviewCount = googleReviewCount + appleReviewCount
export const appleRating = 4.6
export const googleRating = 4.4
export const averageRating =
  Math.round(
    ((googleReviewCount * googleRating + appleReviewCount * appleRating) /
      reviewCount) *
      10
  ) / 10
export const usersInMillions = 55
export const modified = '2022-11-01'
